<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { ref, onMounted } from "vue";
import { useForm, Link } from '@inertiajs/vue3';
import Loading from 'vue-loading-overlay';

const props = defineProps({
    year: String,
    countries: Object,
    flash: Object,
    user: Object,
    agents: Object
});
let isLoading = ref(false);
let cities = ref([]);

const handleCountryChange = (e) => {
    const country_id = e.target.value;
    const country = props.countries.find((item) => item.id == country_id);
    cities.value = country.cities;
    AgentEditform.city_id = cities.value.sort((a, b) => a.name.localeCompare(b.name))[0].id;
    isLoading.value = true;
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
};

onMounted(() => {
    const country_id = props.agents?.country_id;
    const country = props.countries.find((item) => item.id == country_id);
    cities.value = country.cities;
    AgentEditform.city_id = props.agents?.city_id;
});

const AgentEditform = useForm({
    agency_name: props.agents?.agency_name,
    agency_telephone: props.agents?.agency_telephone,
    agency_mobile: props.agents?.agency_mobile,
    agency_email: props.agents?.agency_email,
    agency_address: props.agents?.agency_address,
    country_id: props.agents?.country_id,
    city_id: props.agents?.city_id,
    agency_TIN: props.agents?.agency_TIN,
    pan_number: props.agents?.pan_number,
    agent_logo: null,
    company_id: props.agents?.company_id,
    active: props.agents?.active,
    agent_id: props.agents?.id
});

const AgentEditformSubmit = () => {
    AgentEditform.post('/agents/update', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
};

</script>
<style scoped>
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Create Agent" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="card mb-4">
                <h5 class="card-header">Edit Agent <span class="badge bg-label-warning"></span>
                </h5>
                <form class="card-body" @submit.prevent="AgentEditformSubmit">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Agency Name</b></label>
                            <input type="text" class="form-control" placeholder="Agency Name"
                                v-model="AgentEditform.agency_name"
                                :class="{ 'is-invalid': AgentEditform.errors.agency_name }" required>
                            <div v-if="AgentEditform.errors.agency_name" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.agency_name">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Contact No 1</b></label>
                            <input type="text" class="form-control" placeholder="Contact Number 1"
                                v-model="AgentEditform.agency_telephone"
                                :class="{ 'is-invalid': AgentEditform.errors.agency_telephone }">
                            <div v-if="AgentEditform.errors.agency_telephone" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.agency_telephone">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Contact No 2</b></label>
                            <input type="text" class="form-control" placeholder="Contact Number 2"
                                v-model="AgentEditform.agency_mobile">
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Email</b></label>
                            <input type="text" class="form-control" placeholder="Email Address"
                                v-model="AgentEditform.agency_email"
                                :class="{ 'is-invalid': AgentEditform.errors.agency_email }">
                            <div v-if="AgentEditform.errors.agency_email" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.agency_email">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>TIN</b></label>
                            <input type="text" class="form-control" placeholder="TIN Number"
                                v-model="AgentEditform.agency_TIN"
                                :class="{ 'is-invalid': AgentEditform.errors.agency_TIN }">
                            <div v-if="AgentEditform.errors.agency_TIN" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.agency_TIN">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>PAN Number</b></label>
                            <input type="text" class="form-control" placeholder="PAN Number"
                                v-model="AgentEditform.pan_number"
                                :class="{ 'is-invalid': AgentEditform.errors.pan_number }">
                            <div v-if="AgentEditform.errors.pan_number" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.pan_number">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="hotel_image" class="col-form-label"><b>Agency Logo </b><span
                                    class="text-danger">(Unchanged until a new file is uploaded.)</span></label>
                            <input type="file" class="form-control"
                                @input="AgentEditform.agent_logo = $event.target.files[0]"
                                :class="{ 'is-invalid': AgentEditform.errors.agent_logo }">
                            <progress v-if="AgentEditform.progress" :value="AgentEditform.progress.percentage" max="100">
                                {{ AgentEditform.progress.percentage }}%
                            </progress>
                            <div v-if="AgentEditform.errors.agent_logo" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.agent_logo">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="hotel_id" class="form-label"><b>Country</b></label>
                            <select class="form-select" v-model="AgentEditform.country_id"
                                :class="{ 'is-invalid': AgentEditform.errors.country_id }" @change="handleCountryChange">
                                <option value="" disabled="disabled" selected="selected">Select a country ...</option>
                                <option v-for="countries in props.countries" :value="countries.id">
                                    {{ countries.name }}</option>
                            </select>
                            <div v-if="AgentEditform.errors.country_id" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.country_id">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="city_id" class="form-label"><b>City</b></label>
                            <select class="form-select" name="city_id" v-model="AgentEditform.city_id"
                                :class="{ 'is-invalid': AgentEditform.errors.city_id }">
                                <option value="" disabled="disabled" selected="selected">Select a city ...</option>
                                <option v-for="city in cities" :key="city.id" :value="city.id">
                                    {{ city.name }}</option>
                            </select>
                            <div v-if="AgentEditform.errors.city_id" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.city_id">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="meal_type" class="form-label"><b>Agency Address</b></label>
                            <textarea name="collapsible-address" class="form-control" v-model="AgentEditform.agency_address"
                                rows="2" placeholder="Agency Address"
                                :class="{ 'is-invalid': AgentEditform.errors.agency_address }"></textarea>
                            <div v-if="AgentEditform.errors.agency_address" class="invalid-feedback">
                                <div v-text="AgentEditform.errors.agency_address">
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="my-4 mx-n4">
                    <div class="modal-footer border-0 mt-3">
                        <Link type="button" class="btn btn-label-secondary" :href="'/agents'">
                        Cancel
                        </Link>
                        <button type="submit" class="btn btn-primary me-sm-3 me-1"
                            :disabled="AgentEditform.processing">Update
                            Agent</button>
                    </div>
                </form>
            </div>
        </div>
    </AppLayout>
</template>